import { post } from "../http/platformServer";
import { PagedResult, PagedParams } from "@/services/api/types";
import ShopType from "@/enum/ShopType";
import moment from "moment";

interface GetRecordListParams extends PagedParams {
    shopId: number;
}

export interface OrderVolumeConsumptionRecord {
    date: string;
    id: number;
    orderVolume: number;
    orderVolumeAfterConsumption: number;
    sellerUsername: string;
    shopType: ShopType;
    totalOrders: number;
}

/**
 * 按时间DESC排序展示消费记录
 */
export function getOrderVolumeConsumptionRecordList(params: GetRecordListParams) {
    return post<PagedResult<OrderVolumeConsumptionRecord>>(
        params.shopId,
        "/order_volume/list_consumption_records",
        params,
    );
}

export async function getOrderVolumeConsumptionInfo(shopId: number) {
    let remaining = await getAdditionalOrderVolume(shopId);

    if (typeof remaining !== "number") {
        remaining = 0;
    }

    return {
        remaining: remaining,
        updatedTime: moment().format("YYYY-MM-DD"),
    };
}

export interface OrderVolumePurchaseRecord {
    amount: number;
    dateCreated: string;
    id: number;
    orderVolume: number;
    orderVolumeAfterPurchase: number;
    prepaidAccountId: number;
}

/**
 * 按时间DESC排序展示购买记录
 */
export function getOrderVolumePurchaseRecordList(params: GetRecordListParams) {
    return post<PagedResult<OrderVolumePurchaseRecord>>(params.shopId, "/order_volume/list_purchase_records", params);
}

/**
 * 购买增量订单额度，传入购买数量，1个表示1万订单
 */
export function purchaseOrderVolume(shopId: number, packQuantity: number) {
    return post<string>(shopId, "/order_volume/purchase", {
        shopId,
        packQuantity,
    });
}

/**
 * 判断店铺是否有增量订单额度购买记录
 */
export function getAdditionalOrderVolume(shopId: number) {
    return post<number>(shopId, "/order_volume/get_additional_order_volume", {
        shopId,
    });
}
